module.exports = __webpack_public_path__ + "static/img/pic_3_2@2x.01ce99c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productServices/anchorOperation/peripheralProducts/pic_3_2@2x.png
// module id = bLla
// module chunks = 0